<template>
    <dropdown
        :caret="false"
        :customPopperOptions="{
            strategy: 'fixed',
        }"
        :disabled="isLoading"
        :placement="placement"
        :teleport="teleport"
        class="action-menu"
        toggler-classes="btn-rounded btn-icon"
        @click.stop=""
    >
        <template #toggler>
            <more v-if="!isLoading" />
            <spinner v-else />
        </template>

        <slot />
    </dropdown>
</template>
<script setup>
import Dropdown from '@/Components/Dropdown.vue';
import More from '../../icons/More.vue';

defineProps({
    isLoading: { type: Boolean, default: false },
    placement: { type: String, default: 'left-start' },
    teleport: { type: Boolean, default: false },
});
</script>
